import clsx from 'clsx'
import Image from 'next/image'
import Link from 'next/link'

import { PATHS } from 'shared/utils/paths'
import { addTestId } from 'shared/utils/tests'

import styles from './UnsubscribeNavigation.module.scss'

const UnsubscribeNavigation = ({ className }: { className?: string }) => {
  return (
    <div className={clsx(styles.wrapper, className)}>
      <div className={styles.content}>
        <Link
          className={styles.logoLink}
          href={PATHS.home}
          {...addTestId('navigation-logo')}
        >
          <Image
            className={styles.logo}
            src='/static/lokalny-rolnik.svg'
            alt='Logo Lokalny Rolnik'
            width={139}
            height={43}
          />
        </Link>
      </div>
    </div>
  )
}

export default UnsubscribeNavigation
